import { render } from "./App.vue?vue&type=template&id=a5e4867e"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=a5e4867e&lang=scss"
script.render = render

export default script